import { useEffect } from "react";
import {
  contextMenuStore,
  useContextMenu,
  type ContextMenuItem,
} from "../os/context-menu";

export function ContextMenuHost() {
  const menu = useContextMenu();

  useEffect(() => {
    if (!menu) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") contextMenuStore.close();
    };
    const onDown = (e: MouseEvent) => {
      const t = e.target as HTMLElement | null;
      if (t?.closest?.(".ctx-menu")) return;
      contextMenuStore.close();
    };
    const onScroll = () => contextMenuStore.close();
    window.addEventListener("keydown", onKey);
    window.addEventListener("mousedown", onDown, true);
    window.addEventListener("blur", onScroll);
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("mousedown", onDown, true);
      window.removeEventListener("blur", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [menu]);

  if (!menu) return null;

  return (
    <div
      className="ctx-menu glass glass-strong"
      style={{ left: menu.x, top: menu.y }}
      role="menu"
      onContextMenu={(e) => e.preventDefault()}
    >
      {menu.items.map((item) =>
        "separator" in item && item.separator ? (
          <div key={item.id} className="ctx-sep" />
        ) : (
          <CtxRow
            key={item.id}
            item={item as Exclude<ContextMenuItem, { separator: true }>}
          />
        )
      )}
    </div>
  );
}

function CtxRow({
  item,
}: {
  item: Extract<ContextMenuItem, { label: string }>;
}) {
  const Icon = typeof item.icon === "function" ? item.icon : null;
  return (
    <button
      type="button"
      role="menuitem"
      className={`ctx-item ${item.danger ? "danger" : ""}`}
      disabled={item.disabled}
      onClick={() => {
        if (item.disabled) return;
        contextMenuStore.close();
        item.action();
      }}
    >
      <span className="ctx-icon">{Icon ? <Icon size={12} strokeWidth={2} /> : null}</span>
      <span className="ctx-label">{item.label}</span>
      {item.shortcut && <span className="ctx-shortcut">{item.shortcut}</span>}
    </button>
  );
}
